/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_No_Data_DescriptionInputs */

const es_admin_billing_last_bill_no_data_description = /** @type {(inputs: Admin_Billing_Last_Bill_No_Data_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se registraron movimientos en esta categoría.`)
};

const en_admin_billing_last_bill_no_data_description = /** @type {(inputs: Admin_Billing_Last_Bill_No_Data_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity has been recorded in this category yet.`)
};

/**
* | output |
* | --- |
* | "No activity has been recorded in this category yet." |
*
* @param {Admin_Billing_Last_Bill_No_Data_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_no_data_description = /** @type {((inputs?: Admin_Billing_Last_Bill_No_Data_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_No_Data_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_no_data_description(inputs)
	return en_admin_billing_last_bill_no_data_description(inputs)
});
export { admin_billing_last_bill_no_data_description as "admin.billing.last_bill.no_data_description" }